export default __webpack_public_path__ + "static/media/header_lumen_icon.c055683b.svg";